// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_lq-0";
export var fileCarousel = "_lq-2";
export var removeFileButton = "_lq-1";